import { server } from "../config/vars";

export const API_URL = `${server.uri}/v1`;
export const SPOTIFY_API_URL = "https://api.spotify.com/v1";
